import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CssTemplateDto} from '../model/Theme';
import {CssTemplateVersionDto} from '../model/Theme';

@Injectable({
    providedIn: 'root'
})
export class CssTemplateService {
    private baseUrl = `${environment.apiBaseUrl}/mdds/templates`;

    constructor(private http: HttpClient) {
    }

    getAllTemplates(): Observable<CssTemplateDto[]> {
        return this.http.get<CssTemplateDto[]>(`${this.baseUrl}`);
    }

    getById(id: string): Observable<CssTemplateDto> {
        return this.http.get<CssTemplateDto>(`${this.baseUrl}/${id}`);
    }

    create(template: CssTemplateDto) {
        return this.http.post<CssTemplateDto>(`${this.baseUrl}/create`, template);
    }

    remove(id: string) {
        return this.http.delete(`${this.baseUrl}/${id}`);
    }

    update(template: CssTemplateDto): Observable<CssTemplateDto> {
        return this.http.put<CssTemplateDto>(`${this.baseUrl}`, template);
    }

    getVersions(id: string): Observable<CssTemplateVersionDto[]> {
        return this.http.get<CssTemplateVersionDto[]>(`${this.baseUrl}/${id}/versions`);
    }

}
